import { actions } from './actions'

const initialState = {
  codigosPostalesRestriccionesMovilidad: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function codigosPostalesRestriccionesMovilidadReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_REQUESTED:
      return {
        ...state,
        codigosPostalesRestriccionesMovilidad: {
          ...state.codigosPostalesRestriccionesMovilidad,
          loading: true,
        },
      }
    case actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_SUCCEEDED:
      return {
        ...state,
        codigosPostalesRestriccionesMovilidad: {
          ...state.codigosPostalesRestriccionesMovilidad,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CPS_LOAD_RESTRICCIONES_MOVILIDAD_FILED:
      return {
        ...state,
        codigosPostalesRestriccionesMovilidad: {
          ...state.codigosPostalesRestriccionesMovilidad,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
